<template lang="pug">
.d-flex.flex-column
  slot(name="prepend")

  app-checkbox-old(
    v-model="inputValue"
    v-bind="$attrs"
    :item="inputValue"
    :error-messages="errorMessages"
    required
  )
    template(#label)
      p.text-body-2
        | Предоставляю согласие на&nbsp;
        template(v-if="!hideModal")
          a(
            @click.stop.prevent="openModal"
          ).redesignPrimaryDarken--text.font-weight-medium
            | обработку предоставляемых в составе заявки персональных данных&nbsp;
        template(v-else)
          | обработку предоставляемых в составе заявки персональных данных&nbsp;
        | в соответствии с требованиями 152-ФЗ

  template(v-if="!hideModal")
    event-agreement-modal(
      v-model="isModalOpen"
      v-bind="$attrs"
    )

  slot(name="append")
</template>

<script>
import EventAgreementModal from './EventAgreementModal.vue';

export default {
  name: 'EventAgreement',
  components: {
    EventAgreementModal,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    hideModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalOpen: false,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    isModalOpen(value) {
      if (value) {
        this.openModal();
      } else {
        this.closeModal();
      }

      this.$emit('update:modal', this.isModalOpen);
    },
  },
  created() {},
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
};
</script>
